import {
  FETCH_PROJECT,
  FETCH_PROJECT_SUCCESS,
  FETCH_PROJECT_FAILURE,
  FETCH_CLIENT_PROJECT_SERVICE,
  FETCH_CLIENT_PROJECT_SERVICE_SUCCESS,
  FETCH_CLIENT_PROJECT_SERVICE_FAILURE, 
  FETCH_CLIENT_PROJECT_DROPDOWN,
  FETCH_CLIENT_PROJECT_DROPDOWN_SUCCESS,
  FETCH_CLIENT_PROJECT_DROPDOWN_FAILURE, 
  FETCH_CLIENT_PROJECT_DROPDOWN_CLEAR, 
  CREATE_PROJECT_REQUEST,
  CREATE_PROJECT_SUCCESS,
  CREATE_PROJECT_FAILURE,
  DELETE_CLIENT_PROJECT,
  DELETE_CLIENT_PROJECT_SUCCESS,
  DELETE_CLIENT_PROJECT_FAILURE,
  CHANGE_PROJECT_STATUS,
  CHANGE_PROJECT_STATUS_SUCCESS,
  CHANGE_PROJECT_STATUS_FAILURE,
  FETCH_MODULE_PROJECT_DROPDOWN,
  FETCH_MODULE_PROJECT_DROPDOWN_SUCCESS,
  FETCH_MODULE_PROJECT_DROPDOWN_FAILURE,
  GET_PROJECT_SERVICE_MAPPING_REQUEST,
  SAVE_PROJECT_SERVICE_MAPPING_REQUEST,
  GET_PROJECT_SERVICE_LIST_REQUEST,
  GET_PROJECT_STATUS_BILLING_REQUEST,
  SAVE_PROJECT_STATUS_BILLING_REQUEST,
  CHANGE_PROJECT_BILLING_STATUS_REQUEST,
  GET_PROSERVICE_LIST_REQUEST,
  GET_ORG_PROJECT_COUNT_REQUEST, 
} from "./actionTypes";

// Fetch Project
export const fetchProject = (unitId,create_by) => ({
  type: FETCH_PROJECT,
  payload: { unitId,create_by }
});

export const fetchProjectSuccess = (roles) => ({
  type: FETCH_PROJECT_SUCCESS,
  payload: roles,
});

export const fetchProjectFailure = (error) => ({
  type: FETCH_PROJECT_FAILURE,
  payload: error,
});

export const fetchClientProjectService = (payload) => ({
  type: FETCH_CLIENT_PROJECT_SERVICE,
  payload: payload
});

export const fetchClientProjectServiceSuccess = (roles) => ({
  type: FETCH_CLIENT_PROJECT_SERVICE_SUCCESS,
  payload: roles,
});

export const fetchClientProjectServiceFailure = (error) => ({
  type: FETCH_CLIENT_PROJECT_SERVICE_FAILURE,
  payload: error,
});

export const fetchClientProjectDropdown = (payload) => ({
  type: FETCH_CLIENT_PROJECT_DROPDOWN,
  payload: payload
});

export const fetchClientProjectDropdownSuccess = (roles) => ({
  type: FETCH_CLIENT_PROJECT_DROPDOWN_SUCCESS,
  payload: roles,
});

export const fetchClientProjectDropdownFailure = (error) => ({
  type: FETCH_CLIENT_PROJECT_DROPDOWN_FAILURE,
  payload: error,
});

export const fetchClientProjectDropdownClear = () => ({
  type: FETCH_CLIENT_PROJECT_DROPDOWN_CLEAR,
  payload: '',
});

// Create Project
export const createProjectRequest = (formData, isEdit) => ({
  type: CREATE_PROJECT_REQUEST,
  payload: { formData, isEdit },
});

export const createProjectSuccess = (response) => ({
  type: CREATE_PROJECT_SUCCESS,
  payload: response,
});

export const createProjectFailure = (error) => ({
  type: CREATE_PROJECT_FAILURE,
  payload: error,
});

export const changeProjectStatus = (payload) => ({
  type: CHANGE_PROJECT_STATUS,
  payload,
});

export const changeProjectStatusSuccess = (response) => ({
  type: CHANGE_PROJECT_STATUS_SUCCESS,
  payload: response,
});

export const changeProjectStatusFailure = (error) => ({
  type: CHANGE_PROJECT_STATUS_FAILURE,
  payload: error,
});

// Delete Project
export const deleteClientProject = (formdata) => ({
  type: DELETE_CLIENT_PROJECT,
  payload: formdata,
});

export const deleteClientProjectSuccess = (response) => ({
  type: DELETE_CLIENT_PROJECT_SUCCESS,
  payload: response,
});

export const deleteClientProjectFailure = (error) => ({
  type: DELETE_CLIENT_PROJECT_FAILURE,
  payload: error,
});

export const fetchModuleProject = (payload) => ({
  type: FETCH_MODULE_PROJECT_DROPDOWN,
  payload: payload
});

export const fetchModuleProjectSuccess = (roles) => ({
  type: FETCH_MODULE_PROJECT_DROPDOWN_SUCCESS,
  payload: roles,
});

export const fetchModuleProjectFailure = (error) => ({
  type: FETCH_MODULE_PROJECT_DROPDOWN_FAILURE,
  payload: error,
});

/* Get project–service mapping list */
export const getProjectServiceMappingList = (payload) => ({
  type: GET_PROJECT_SERVICE_MAPPING_REQUEST,
  payload, // { project_id }
});

export const getProjectServiceList = (payload) => ({
  type: GET_PROJECT_SERVICE_LIST_REQUEST,
  payload, // FormData { clientId, unitId }
});

/* Save project–service mapping */
export const saveProjectServiceMapping = (payload) => ({
  type: SAVE_PROJECT_SERVICE_MAPPING_REQUEST,
  payload, // { project_id, service_ids: [] }
});

// Get project status billing
export const getProjectStatusBilling = (payload) => ({
  type: GET_PROJECT_STATUS_BILLING_REQUEST,
  payload, // { project_id }
});

// Save project status billing
export const saveProjectStatusBilling = (payload) => ({
  type: SAVE_PROJECT_STATUS_BILLING_REQUEST,
  payload, // billing form data
});

// Change billing project status
export const changeProjectBillingStatus = (payload) => ({
  type: CHANGE_PROJECT_BILLING_STATUS_REQUEST,
  payload, // { project_id, status }
});

export const getProserviceList = (payload) => ({
  type: GET_PROSERVICE_LIST_REQUEST,
  payload, 
});

export const getOrgProjectCount = (payload) => ({
  type: GET_ORG_PROJECT_COUNT_REQUEST,
  payload,
});
